<template>
  <div class="notfound-container d-flex flex-column h-100">
    <section class="col-md-6 container">
      <div class="form-upgrade card">
        <div class="row">
          <div class="col-md-12">
            <div class="upgrade-heading">
              <h5 class="py-3 text-green">UPGRADE SUBSCRIPTION PACKAGE</h5>
            </div>
            <div class="py-2 bg-grey200">
              <div
                v-for="(card, index) in currentSubscription"
                :key="index"
                class="upgrade-plan py-3"
              >
                <p>CURRENT PLAN: {{ card.title }}</p>
                <p>{{ card.description }}</p>
                <p>{{ card.currency }} {{ card.price }}</p>
              </div>
              <div
                v-for="(card, index) in cardSelected"
                :key="index"
                class="upgrade-plan"
              >
                <p>NEW PLAN: {{ card.title }}</p>
                <p>{{ card.description }}</p>
                <p>{{ card.currency }} {{ card.price }}</p>
              </div>
            </div>
            <div class="upgrade-plan py-3">
              <p>You won’t be charged until 11/08/2020</p>
              <div class="buttons">
                <a
                  @click="onclickconfirmSubscription"
                  class="btn btn-primary btn-lg"
                >
                  {{ getText("confirm_change_button_text") }}
                </a>
                <a @click="onClickCancel" class="btn btn-light btn-lg ml-2"
                  >Cancel</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: "ConfirmSubscription",
  props: ["selectedCard", "currentPackage", "currentPlan"],
  components: {},

  methods: {
    getText(val) {
      		return this.$store.getters.getGlobalConfigs[val];
    	},
    onClickCancel(event) {
      this.$emit("clicked", "cancel");
    },
    onclickconfirmSubscription() {

    this.$store.commit("setNotification", "Coming Soon..");

      //// Code  For Version two /////


    //   let dataToSend = {};
    //   dataToSend.slug =this.subscriptionSlug
    //    dataToSend.subscriptionId = this.selectedCard.sub_id;
    //   this.$store.commit("setLoader", true);
    //   if( this.flutterUser == true ){
    //   this.$store
    //     .dispatch("ChangeSubscription", dataToSend)
    //     .then((res) => {
    //       if (res) {
    //         this.$store.commit("setLoader", false);
    //         this.$store.commit(
    //           "setNotification",
    //           " Sucessfully sent Request for Upgrade Subscription"
    //         );
    //         this.$router.push("/home");
    //       }
    //     })
    //     .catch((err) => {
    //       this.$store.commit("setLoader", false);
    //       this.$store.commit(
    //         "setNotification",
    //         " Upgrade Subscription Request Failed Please Try again Later"
    //       );
    //       this.$router.push("/account");
    //     });
    // } else 
    // this.$store.commit("setLoader", false);
    // this.$store.commit(
    //         "setNotification",
    //         " Update subscription on selected payment method is not available"
    //       );
    //       this.$router.push("/account");
    }
  },

  created() {
       this.$store.commit("showPopup", false);
    this.cardSelected.push(this.selectedCard);
    this.currentSubscription.push(this.currentPlan);
    this.$store.dispatch("account").then((res) => {
      if (res) {
        this.userSubscription = res.response.subscriptions;
        if (this.userSubscription[0].subscription_slug) {
          if (this.userSubscription[0].payment_gateway == "flutterwave") {
            this.flutterUser = true;
            this.subscriptionSlug = this.userSubscription[0].subscription_slug;
          } else this.flutterUser = false;
        } else this.flutterUser = false;
      }
    });
  },

  data() {
    return {
      someValue: false,
      cardSelected: [],
      currentSubscription: [],
      userSubscription: null,
      flutterUser: null,
      subscriptionSlug: null,
    };
  },
};
</script>

<style scoped>
.container {
  align-items: center;
  padding-top: 10%;
}
.card {
  border-radius: 20px;
}
.buttons {
  padding-left: 18%;
  padding-bottom: 20px;
  padding-top: 30px;
}
.upgrade-plan {
  padding-left: 30px;
}
.upgrade-plan > p {
  padding-top: 0px;
  padding-bottom: 5px;
  margin-top: 0px;
  margin-bottom: 0px;
}
.upgrade-heading {
  padding-left: 50px;
  padding-top: 30px;
}
</style>